import { SVGProps } from 'react';

const Crown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 21h14M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.811a1 1 0 0 1-.958-.734L2.02 6.02a.5.5 0 0 1 .798-.52l4.276 3.665A1 1 0 0 0 8.61 8.87z"
    />
  </svg>
);
export default Crown;
